export default "<div id=\"legend\"></div>\n"